import React from "react";
import { Modal } from "antd";

const ConfirmBox = ({ visible, onConfirm, onCancel }) => {
  return (
    <Modal
      title="Logout"
      className="logoutModel"
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Yes Logout"
      cancelText="Cancel"
    >
      <p>Are you sure you want to logout?</p>
    </Modal>
  );
};

export default ConfirmBox;
